"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderComponent = exports.StyledSlider = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
var Image_1 = __importDefault(require("../../elements/Image"));
var _helpers_1 = require("../../../helpers");
var rc_slider_1 = require("rc-slider");
require("rc-slider/assets/index.css");
var Slider_1 = __importDefault(require("rc-slider/lib/Slider"));
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Questionnaire_1 = require("../../../defaults/Questionnaire");
var Questionnaire_2 = require("../Questionnaire");
exports.StyledSlider = styled_components_1.default(Slider_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 50px 0 50px;\n  @media (max-width: ", ") {\n    margin: 0 0 50px;\n  }\n"], ["\n  margin: 50px 0 50px;\n  @media (max-width: ", ") {\n    margin: 0 0 50px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
});
var SliderComponent = function (_a) {
    var _b;
    var _c, _d, _e;
    var mainColor = _a.mainColor, defaultValue = _a.defaultValue, mergedButtons = _a.mergedButtons, question = _a.question, setAnswer = _a.setAnswer, visible = _a.visible, onSelect = _a.onSelect, setDisabledActions = _a.setDisabledActions;
    var _f = react_1.useState(visible), visibleAfterTimeout = _f[0], setVisibleAfterTimeout = _f[1];
    var _g = react_1.useState(), sliderValue = _g[0], setSliderValue = _g[1];
    var setValue = function (v) {
        setAnswer(v);
        setSliderValue(v);
    };
    var mergedRangeConfig = _helpers_1.merge(Questionnaire_1.defaultRangeConfig, {
        trackStyle: { backgroundColor: mainColor },
        handleStyle: {
            borderColor: mainColor,
            backgroundColor: mainColor
        }
    });
    var rangeConfig = __assign(__assign({}, mergedRangeConfig), question.rangeConfig);
    var min = (rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.min) || 0;
    var max = (rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.max) || 100;
    var color = (_c = rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.trackStyle) === null || _c === void 0 ? void 0 : _c.backgroundColor;
    react_1.useEffect(function () {
        // Set init value
        if (visible && !sliderValue)
            setValue(defaultValue);
        // This timeout helps with the animation, or else the label will be rendered off-screen
        if (!visible)
            setVisibleAfterTimeout(false);
        else {
            setDisabledActions(true);
            setTimeout(function () {
                setDisabledActions(false);
                setVisibleAfterTimeout(visible);
            }, 501);
        }
    }, [visible, defaultValue]);
    react_1.useEffect(function () {
        var tooltips = document.getElementsByClassName('rc-slider-tooltip-arrow');
        Array.from(tooltips).forEach(function (tooltip) {
            tooltip.style.borderTopColor = 'rgba(255,255,255,0)';
        });
    }, [visibleAfterTimeout, color]);
    return (react_1.default.createElement(Questionnaire_2.CardContent, { className: "no-user-select", id: "sliderCardContainer-" + question.step },
        react_1.default.createElement("div", { className: "columns is-marginless is-multiline" },
            (question === null || question === void 0 ? void 0 : question.image) && (react_1.default.createElement("div", { className: "column is-hidden-tablet is-6-mobile is-offset-3-mobile" },
                react_1.default.createElement(Image_1.default, __assign({}, question.image)))),
            react_1.default.createElement("div", { className: "column is-12-mobile is-8-tablet is-8-desktop is-8-widescreen is-flex is-flex-direction-column pt-0" },
                react_1.default.createElement("div", { className: "column is-flex is-align-items-center px-0" },
                    react_1.default.createElement(exports.StyledSlider, __assign({}, rangeConfig, { value: sliderValue || 0, handle: function (props) {
                            var value = props.value, index = props.index, restProps = __rest(props, ["value", "index"]);
                            return (react_1.default.createElement(rc_slider_1.SliderTooltip, { prefixCls: "rc-slider-tooltip", overlayStyle: { zIndex: 1000 }, overlay: value + " " + ((rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.label) || ''), overlayInnerStyle: {
                                    backgroundColor: 'rgba(255,255,255,0)',
                                    color: '#000',
                                    boxShadow: 'none',
                                    minWidth: 50,
                                    height: 'auto',
                                    fontSize: 16
                                }, visible: visibleAfterTimeout, placement: "top", getTooltipContainer: function () {
                                    return document.getElementById("sliderCardContainer-" + question.step);
                                }, key: index },
                                react_1.default.createElement(rc_slider_1.Handle, __assign({}, restProps))));
                        }, marks: (_b = {},
                            _b[min] = {
                                style: {
                                    marginTop: 10,
                                    color: 'rgb(120,120,120)',
                                    fontSize: 14,
                                    minWidth: 75,
                                    textAlign: 'left',
                                    transform: 'none'
                                },
                                label: "< " + (rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.min) + ((rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.label) || '')
                            },
                            _b[max] = {
                                style: {
                                    marginTop: 10,
                                    color: 'rgb(120,120,120)',
                                    fontSize: 14,
                                    minWidth: 75,
                                    textAlign: 'right',
                                    transform: 'translateX(-100%)'
                                },
                                label: "> " + (rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.max) + ((rangeConfig === null || rangeConfig === void 0 ? void 0 : rangeConfig.label) || '')
                            },
                            _b), onChange: function (v) { return setValue(v); } }))),
                react_1.default.createElement(Questionnaire_2.AlternativeInput, null,
                    react_1.default.createElement("label", null, (_d = question.textConfig) === null || _d === void 0 ? void 0 : _d.label),
                    react_1.default.createElement(Questionnaire_2.Input, { type: 'number', value: sliderValue || undefined, onChange: function (event) { return setValue(Number(event.target.value) || null); }, placeholder: (_e = question.textConfig) === null || _e === void 0 ? void 0 : _e.placeholder }))),
            react_1.default.createElement("div", { className: "column is-hidden-mobile is-4-tablet is-4-desktop is-4-widescreen is-flex is-flex-direction-column pt-0 is-justify-content-space-between" },
                (question === null || question === void 0 ? void 0 : question.image) && react_1.default.createElement(Image_1.default, __assign({}, question.image)),
                question.nextStep &&
                    (question.type === Questionnaire_2.QuestionTypes.range ||
                        question.type === Questionnaire_2.QuestionTypes.text) && (react_1.default.createElement(Questionnaire_2.StyledButton, __assign({ mainColor: mainColor }, mergedButtons.next, { width: '100%', onClick: onSelect }),
                    mergedButtons.next.text,
                    react_1.default.createElement("i", { className: "material-icons" }, "navigate_next")))))));
};
exports.SliderComponent = SliderComponent;
var templateObject_1;
//# sourceMappingURL=SliderComponent.js.map